import { useState, useRef, useCallback, useEffect } from "react";

/**
 * State that auto-clears after a delay. Safe on unmount.
 * Usage: const [msg, setMsg] = useTimedMessage(2000);
 *        setMsg("Copied!");  // clears after 2s
 */
export default function useTimedMessage(delay = 2000) {
  const [value, setValue] = useState("");
  const timerRef = useRef(null);

  const set = useCallback((msg) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setValue(msg);
    timerRef.current = setTimeout(() => setValue(""), delay);
  }, [delay]);

  useEffect(() => {
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, []);

  return [value, set];
}
